var map = {
	"./discord.png": "2362",
	"./fb.png": "0499",
	"./google.png": "54e1",
	"./pay-qiwi.png": "1796",
	"./pay-yandex.png": "fdfd",
	"./steam_logo.png": "92c7",
	"./vk.png": "2d15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ea0";